
export default class SkillsService {
    firstRun = true
    #localSkills
    async getSkills() {
        const localKey = 'localAdvisorsString'
        // Load the skills from the server the first time this function is called. 
        if (this.firstRun) {
            localStorage.removeItem(localKey)
        }
        this.firstRun = false

        // First, check to see if we have already loaded it into memory on the shared instance
        // If Vue wipes this all the time, then direct mockery to Dane
        if (this.#localSkills != null && this.#localSkills.length > 0) {
            return this.#localSkills
        }
        
        let localString = localStorage.getItem(localKey)
        if (localString != null && localString.length > 0) {
            let parsed = JSON.parse(localString)
            this.#localSkills = parsed
            return parsed
        }

        let remoteSkillResponse = await this.$http.get('/info/skills')
        let skillData = remoteSkillResponse.data.data
        this.#localSkills = skillData
        localStorage.setItem(localKey, JSON.stringify(skillData))
        return skillData
    }

    // Returns the skills mapped to the values used for multiple selection within the app
    #localSkillsAsValues
    async getSkillsAsValues(useSlugs) {
        const asSlugs = useSlugs != null && useSlugs === true
        if (this.#localSkillsAsValues != null && this.#localSkillsAsValues.length > 0) {
            let returnValue = asSlugs === true ? this.valuesAsSlugs(this.#localSkillsAsValues) : this.#localSkillsAsValues
            return returnValue
        }
        const skills = await this.getSkills()
        const mapped = skills.map((skill) => {
            return { text: skill.title, value: skill.id }
        })
        this.#localSkillsAsValues = mapped
        return asSlugs === true ? this.valuesAsSlugs(mapped) : mapped
    }

    valuesAsSlugs(values) {
        return values.map((value) => {
            return {
                text: value.text.split(' ')[0],
                value: value.value
            }
        })
    }
}